import { useFormikAutoScroll } from '@/hooks/useAutoScrollWhenErrors';
import { Form } from 'formik';
import { HTMLProps, ReactNode } from 'react';

interface EnhancedFormikFormProps extends HTMLProps<HTMLFormElement> {
  children: ReactNode;
  noValidate?: boolean;
}

export const EnhancedFormikForm = ({ children, ...props }: EnhancedFormikFormProps) => {
  useFormikAutoScroll();
  return <Form {...props}>{children}</Form>;
};
